import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { X_AXIS_TYPE } from "@shared/enums/x-axis-type.enum";

@Component({
  selector: 'app-pd-toggle-type',
  templateUrl: './pd-toggle-type.component.html',
  styleUrls: ['./pd-toggle-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdToggleTypeComponent implements OnInit {
  public isDateType: boolean = false;
  @Input() public config: string | null;

  @Output() toggleChanged: EventEmitter<string> = new EventEmitter<string>();

  public ngOnInit(): void {
    if (this.config === X_AXIS_TYPE.DATETIME) {
      this.isDateType = true;
    } else if (this.config === X_AXIS_TYPE.LINEAR) {
      this.isDateType = false;
    }
  }

  public toggleCurrentType(): void {
    this.isDateType = !this.isDateType;
    this.toggleChanged.emit(this.isDateType ? X_AXIS_TYPE.DATETIME : X_AXIS_TYPE.DATE_GAP);
  }
}
